import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CompanyService } from '../company.service';

export const useGetCompanies = (
	params?: Companies.CompanyParams,
	options?: Omit<
		UseQueryOptions<Companies.GetCompaniesResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['companies', params],
		queryFn: () => CompanyService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetCompany = (
	id: string,
	options?: Omit<
		UseQueryOptions<Companies.CompanyDetail, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['company', id],
		queryFn: () => CompanyService.getById(id),
		enabled: !!id,
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetMyCompany = (
	options?: Omit<
		UseQueryOptions<Companies.MyCompany | null, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['company', 'my'],
		queryFn: () => CompanyService.getMyCompany(),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetPlans = (
	params?: { id?: string; active?: boolean },
	options?: Omit<
		UseQueryOptions<Companies.Plan[], Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['plans', params],
		queryFn: () => CompanyService.getPlans(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetSubscriptions = (
	params?: Companies.SubscriptionParams,
	options?: Omit<
		UseQueryOptions<Companies.Subscription[], Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['subscriptions', params],
		queryFn: () => CompanyService.getSubscriptions(params),
		refetchOnWindowFocus: false,
		...options,
	});
};
